import React from 'react'
import _ from 'lodash'

import {Select} from 'antd'

export class PickColumns extends React.Component {
   static get propTypes() {
      return {
         onUpdate: React.PropTypes.func.isRequired,
         columns:  React.PropTypes.array,
         options:  React.PropTypes.array
      }
   }

   static get defaultProps() {
      return {
         columns: ['datetime', 'network', 'device', 'proto/tm.type', 'proto/tm.detail'],
         options: null
      }
   }

   constructor() {
      super()

      this.state = {
         options: null
      }
   }

   componentWillReceiveProps(next) {
      // expand the props
      this.buildOptions(next)
   }

   componentWillMount() {
      // check if props is specified in the incoming props, otherwise notify parent
      // that we set the columns
      if (null === this.props.columns) {
         this.props.onUpdate(PickColumns.defaultProps.columns, false)
      }

      this.buildOptions(this.props)
   }

   buildOptions(next) {
      if (!this.props.options) {
         this.setState({
            options: _.map(next.columns, label => {
               return {label, value: label}
            })
         })
      }
   }

   render() {
      const {columns, options, onUpdate, ...props} = this.props

      return (
         <Select
            mode="tags"
            placeholder="key, datetime, ..."
            onChange={values => onUpdate(values, true)}
            value={(columns || []).filter(a => !!a)}
            tokenSeparators={[',', ' ']}
            style={{width: '100%'}}
            allowClear={true}
            {...props}
         >
            {_.map(options || this.state.options, ({label, value}, idx) => (
               <Select.Option key={idx} value={value}>{label || value}</Select.Option>
            ))}
         </Select>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/ui/PickColumns.jsx